import { render } from "./PatientOtherDetails.vue?vue&type=template&id=34a0f08c&ts=true"
import script from "./PatientOtherDetails.vue?vue&type=script&lang=ts"
export * from "./PatientOtherDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__